import { useState, useEffect } from "react";

function HouseDesignDropdownModal({
  isOpen,
  onClose,
  houseDesigns,
  buyThisPlan,
  onSubmit,
}) {
  const [selectedId, setSelectedId] = useState("");
  const [selectedPriceKey, setSelectedPriceKey] = useState("");

  useEffect(() => {
    if (isOpen) {
      setSelectedId("");
      setSelectedPriceKey("");
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = () => {
    if (
      selectedId &&
      selectedPriceKey &&
      buyThisPlan &&
      buyThisPlan[selectedPriceKey]
    ) {
      onSubmit(selectedId, parseInt(buyThisPlan[selectedPriceKey]));
    }
  };

  const priceOptions = Object.entries(buyThisPlan || {}).filter(
    ([key]) => key !== "id" && key !== "name"
  );

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-md w-[400px]">
        <h3 className="text-lg font-semibold mb-4">Associate House Design</h3>

        <select
          value={selectedId}
          onChange={(e) => setSelectedId(e.target.value)}
          className="w-full p-2 mb-3 border rounded-md"
        >
          <option value="">Select House Design</option>
          {houseDesigns?.map((design) => (
            <option key={design.id} value={design.id}>
              {design.title || `House Design`}
            </option>
          ))}
        </select>

        <select
          value={selectedPriceKey}
          onChange={(e) => setSelectedPriceKey(e.target.value)}
          className="w-full p-2 mb-4 border rounded-md"
        >
          <option value="">Select Price</option>
          {priceOptions.map(([key, value]) => (
            <option key={key} value={key}>
              {`${key.replaceAll("_", " ")} - Rs. ${value}`}
            </option>
          ))}
        </select>

        <div className="flex justify-end gap-3">
          <button
            type="button"
            className="btn btn-reset-filter justify-center"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary justify-center"
            onClick={handleSubmit}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

export default HouseDesignDropdownModal;
